var _path, _path2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhone = function SvgPhone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 1C9.78571 1 2.75714 1.58572 2.17143 6.85715M2.17143 6.85715H4.51428M2.17143 6.85715C1.78095 6.85715 1 7.09143 1 8.02857C1 9.2 1 10.3714 2.17143 10.3714C2.79753 10.3714 4.32992 10.3714 5.68571 10.3714M13.3 5.1C9.55143 5.1 8.22381 6.27143 8.02857 6.85715L8.61428 8.61429C8.61428 8.80953 8.61428 9.31714 8.61428 9.78572C8.61428 10.2543 7.83333 10.3714 7.44286 10.3714C6.98925 10.3714 6.35927 10.3714 5.68571 10.3714M13.3 21.5H5.68571C4.90476 21.5 3.34286 21.0314 3.34286 19.1571C3.34286 17.2829 4.90476 12.519 5.68571 10.3714",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8857 1C17.4 1 24.4286 1.58572 25.0143 6.85715M25.0143 6.85715H22.6714M25.0143 6.85715C25.4048 6.85715 26.1857 7.09143 26.1857 8.02857C26.1857 9.2 26.1857 10.3714 25.0143 10.3714C24.3882 10.3714 22.8558 10.3714 21.5 10.3714M13.8857 5.1C17.6343 5.1 18.9619 6.27143 19.1572 6.85715L18.5714 8.61429C18.5714 8.80953 18.5714 9.31714 18.5714 9.78572C18.5714 10.2543 19.3524 10.3714 19.7429 10.3714C20.1965 10.3714 20.8265 10.3714 21.5 10.3714M13.8857 21.5H21.5C22.281 21.5 23.8429 21.0314 23.8429 19.1571C23.8429 17.2829 22.281 12.519 21.5 10.3714",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3,
    cy: 14.4714,
    r: 3.1,
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.c0f20a3b6569471b237b09723a3408fb.svg";